import buyFundAssets from "./buyFundAssets";
import fundInvestments from "./fundInvestments";
import fundUnits from "./fundUnits";
import fundProvider from "./fundProvider";
import fundSubscriber from "./fundSubscriber";
import sales from "./Sales";
import salesAndBalance from "./salesAndBalance";
import auth from "./Auth";
import profile from "./profile";
import FundSubscriberDataConsumersProviderMain from "./FundSubscribers";
import dashboard from "./Dashboard";
import fundProviderOld from "./fundProvider";
import tokenizeData from "./tokenizeData";
import buyData from "./buyData";
import YourDataUnit from "./YourDataUnit";
import purchasedDataUnit from "./purchasedDataUnit";
import dataTransaction from "./dataTransaction";
import checkProviderDetail from "./checkProviderDetail";
import registerProvider from "./registerProvider";
import CheckConsumerDetail from "./CheckConsumerDetail";
import checkDataUnitbyType from "./checkDataUnitbyType";
import DataConsumerProvider from "./DataConsumerProvider";
import DataConsumersProviderMain from "./Data Consumers";
import FundSubscriberTransactionsMain from "./FundSubscriberTransactions";

const screens = {
  buyFundAssets,
  fundInvestments,
  fundUnits,
  fundProvider,
  fundSubscriber,
  sales,
  salesAndBalance,
  auth,
  profile,
  FundSubscriberDataConsumersProviderMain,
  dashboard,
  fundProviderOld,
  tokenizeData,
  buyData,
  YourDataUnit,
  purchasedDataUnit,
  dataTransaction,
  checkProviderDetail,
  registerProvider,
  CheckConsumerDetail,
  checkDataUnitbyType,
  DataConsumerProvider,
  DataConsumersProviderMain,
  FundSubscriberTransactionsMain,
};
export default screens;